module.exports = __webpack_public_path__ + "img/emoji_96.1c3899e6.png";